import { createSlice } from "@reduxjs/toolkit";
import {
  toExchangePoints,
  toGetMyLoyaltyHistory,
  toGetMyWalletHistory,
  toGetProfil,
  toLogin,
  toSignup,
  ToEditProfile,
  ToGetQitafOtp,
  toRedeemQitaf,
  toGetRajhiOtp,
  toRedeemRajhi,
  toGetCountries,
  toGetTitles,
  toResetPasswordRequest,
  toContactus,
  toSignupOTP,
  toRegenerateOtp,
} from "../actions/auth.actions";

const initialState = {
  login: {} as any,
  signup: {} as any,
  signupOTP: {} as any,
  regenerateOtp: {} as any,
  resetPassword: {} as any,
  contactUs: {} as any,

  profil: {
    data: {} as any,
    status: "",
  } as any,
  countries: {
    list: [],
    status: "idle",
  } as any,
  titles: {
    list: [],
    status: "idle",
  } as any,
  EditProfile: {
    loading: false,
  } as any,
  exchangePoints: {
    loading: false,
  } as any,
  historyLoyalty: {
    data: [] as any,
    status: "",
  },
  historyWallet: {
    data: [] as any,
    status: "",
  },
  qitafOtp: {
    loading: false,
  } as any,
  redeemQitaf: {
    loading: false,
  } as any,
  rajhiOtp: {
    loading: false,
  } as any,
  redeemRajhi: {
    loading: false,
  } as any,
  loading: false,
  error: null as unknown | null,
};
export const loginSlice = createSlice({
  name: "login",
  initialState: initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(toLogin.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toLogin.fulfilled, (state, action) => {
      state.login = action.payload;
      state.loading = false;
    });
    builder.addCase(toLogin.rejected, (state, action) => {
      state.login = {};
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(toSignup.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toSignup.fulfilled, (state, action) => {
      state.signup = action.payload;
      state.loading = false;
    });
    builder.addCase(toSignup.rejected, (state, action) => {
      state.signup = {};
      state.loading = false;
      state.error = action.payload;
    });
    builder.addCase(toGetProfil.pending, (state) => {
      state.profil = { data: {}, status: "idle" };
    });
    builder.addCase(toGetProfil.fulfilled, (state, action) => {
      if (action.payload) {
        state.profil = { data: action.payload.data, status: "succedded" };
      }
    });
    builder.addCase(toGetProfil.rejected, (state, action) => {
      state.profil = { data: null, status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toExchangePoints.pending, (state) => {
      state.exchangePoints.loading = true;
    });
    builder.addCase(toExchangePoints.fulfilled, (state, action) => {
      state.exchangePoints = action.payload;
      state.exchangePoints.loading = false;
    });
    builder.addCase(toExchangePoints.rejected, (state, action) => {
      state.exchangePoints = {};
      state.exchangePoints.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toGetMyLoyaltyHistory.pending, (state) => {
      state.historyLoyalty.data = { data: [], status: "idle" };
    });
    builder.addCase(toGetMyLoyaltyHistory.fulfilled, (state, action) => {
      if (action.payload) {
        state.historyLoyalty.data = {
          data: action.payload.data,
          status: "succedded",
        };
      }
    });
    builder.addCase(toGetMyLoyaltyHistory.rejected, (state, action) => {
      state.historyLoyalty.data = { data: [], status: "rejected" };
      state.error = action.payload;
    });

    builder.addCase(toGetMyWalletHistory.pending, (state) => {
      state.historyWallet.data = { data: [], status: "idle" };
    });
    builder.addCase(toGetMyWalletHistory.fulfilled, (state, action) => {
      if (action.payload) {
        state.historyWallet.data = {
          data: action.payload.data,
          status: "succedded",
        };
      }
    });
    builder.addCase(toGetMyWalletHistory.rejected, (state, action) => {
      state.historyWallet.data = { data: [], status: "rejected" };
      state.error = action.payload;
    });
    // to edit profile
    builder.addCase(ToEditProfile.pending, (state) => {
      state.EditProfile.loading = true;
    });
    builder.addCase(ToEditProfile.fulfilled, (state, action) => {
      state.EditProfile = action.payload;
      state.EditProfile.loading = false;
    });
    builder.addCase(ToEditProfile.rejected, (state, action) => {
      state.EditProfile = {};
      state.EditProfile.loading = false;
      state.error = action.payload;
    });
    // to get QitafOtp
    builder.addCase(ToGetQitafOtp.pending, (state) => {
      state.qitafOtp.loading = true;
    });
    builder.addCase(ToGetQitafOtp.fulfilled, (state, action) => {
      state.qitafOtp = action.payload;
      state.qitafOtp.loading = false;
    });
    builder.addCase(ToGetQitafOtp.rejected, (state, action) => {
      state.qitafOtp = {};
      state.qitafOtp.loading = false;
      state.error = action.payload;
    });
    // to redeem qitaf
    builder.addCase(toRedeemQitaf.pending, (state) => {
      state.redeemQitaf.loading = true;
    });
    builder.addCase(toRedeemQitaf.fulfilled, (state, action) => {
      state.redeemQitaf = action.payload;
      state.redeemQitaf.loading = false;
    });
    builder.addCase(toRedeemQitaf.rejected, (state, action) => {
      state.redeemQitaf = {};
      state.redeemQitaf.loading = false;
      state.error = action.payload;
    });
    // to get rajhiOtp
    builder.addCase(toGetRajhiOtp.pending, (state) => {
      state.rajhiOtp.loading = true;
    });
    builder.addCase(toGetRajhiOtp.fulfilled, (state, action) => {
      state.rajhiOtp = action.payload;
      state.rajhiOtp.loading = false;
    });
    builder.addCase(toGetRajhiOtp.rejected, (state, action) => {
      state.rajhiOtp = {};
      state.rajhiOtp.loading = false;
      state.error = action.payload;
    });
    // to redeem Rajhi
    builder.addCase(toRedeemRajhi.pending, (state) => {
      state.redeemRajhi.loading = true;
    });
    builder.addCase(toRedeemRajhi.fulfilled, (state, action) => {
      state.redeemRajhi = action.payload;
      state.redeemRajhi.loading = false;
    });
    builder.addCase(toRedeemRajhi.rejected, (state, action) => {
      state.redeemRajhi = {};
      state.redeemRajhi.loading = false;
      state.error = action.payload;
    });
    // to get countries
    builder.addCase(toGetCountries.pending, (state) => {
      state.countries = { list: [], status: "idle" };
    });
    builder.addCase(toGetCountries.fulfilled, (state, action) => {
      state.countries = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetCountries.rejected, (state, action) => {
      state.countries = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to get countries
    builder.addCase(toGetTitles.pending, (state) => {
      state.titles = { list: [], status: "idle" };
    });
    builder.addCase(toGetTitles.fulfilled, (state, action) => {
      state.titles = { list: action.payload.data, status: "succedded" };
    });
    builder.addCase(toGetTitles.rejected, (state, action) => {
      state.titles = { list: [], status: "rejected" };
      state.error = action.payload;
    });
    // to reset password
    builder.addCase(toResetPasswordRequest.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toResetPasswordRequest.fulfilled, (state, action) => {
      state.resetPassword = action.payload;
      state.loading = false;
    });
    builder.addCase(toResetPasswordRequest.rejected, (state, action) => {
      state.resetPassword = {};
      state.loading = false;
      state.error = action.payload;
    });
    // to contact us
    builder.addCase(toContactus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toContactus.fulfilled, (state, action) => {
      state.contactUs = action.payload;
      state.loading = false;
    });
    builder.addCase(toContactus.rejected, (state, action) => {
      state.contactUs = {};
      state.loading = false;
      state.error = action.payload;
    });
    //To sign up Otp
    builder.addCase(toSignupOTP.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toSignupOTP.fulfilled, (state, action) => {
      state.signupOTP = action.payload;
      state.loading = false;
    });
    builder.addCase(toSignupOTP.rejected, (state, action) => {
      state.signupOTP = {};
      state.loading = false;
      state.error = action.payload;
    });
    //To Regenerate Otp
    builder.addCase(toRegenerateOtp.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(toRegenerateOtp.fulfilled, (state, action) => {
      state.regenerateOtp = action.payload;
      state.loading = false;
    });
    builder.addCase(toRegenerateOtp.rejected, (state, action) => {
      state.regenerateOtp = {};
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export default loginSlice.reducer;
